// extracted by mini-css-extract-plugin
export default {"CardsContainer":"OnboardingModal_CardsContainer__EOlWB"};